import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { HttpService } from './shared/services/http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit{
  title = 'test';

  constructor(public router:Router, public appService:AppService, private httpService:HttpService){
    let tokenForCall = (new URLSearchParams(window.location.search)).get("code");
    this.appService.isLoggedIn=false;
    if(tokenForCall){
      sessionStorage.setItem("token", 'Bearer ' + tokenForCall)  
      sessionStorage.setItem("tokenRaw", tokenForCall)  
      this.router.navigateByUrl("/auth");
     
    }
  }

  ngOnInit(): void {
  }

  
}
